import {
  filterAdoverlayData,
  formatAdoverlayData,
  formatAdoverlayForMarker,
} from '@app/modules/logger/screens/stream/components/audit/adoverlay/utils';
import { DateTimeStr, Station, TimeRange, toTimestamp } from '@mi-front/core';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../api';
import { isAdOverlayEnabled } from '../helpers';

export function useAdOverlayMatches(station: Station, range: TimeRange<DateTimeStr>) {
  const fetch = async () => {
    if (!isAdOverlayEnabled(station)) {
      return [];
    }

    const results = await apiClient.audit.fetchAdoverlayRange(
      station.slug,
      {
        from: toTimestamp(range.from),
        to: toTimestamp(range.to),
      },
      true,
    );

    return formatAdoverlayForMarker(formatAdoverlayData(filterAdoverlayData(results)));
  };

  return useQuery({
    queryKey: [
      'ad-overlay-matches',
      {
        station: station.id,
        range,
      },
    ],

    queryFn: fetch,
  });
}
